import styled from '@emotion/styled';

export const Content = styled.div`
  width: 92%;
  max-width: 1280px;
  margin: 0 auto;
`;
